import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { createMetaManager, plugin as metaPlugin } from "vue-meta";
import VueCookieAcceptDecline from "vue-cookie-accept-decline";
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";
import VueGtag from "vue-gtag";
import "./assets/style.scss"

const appVue = createApp(App);
appVue.component("vue-cookie-accept-decline", VueCookieAcceptDecline);

appVue
  .use(
    VueGtag,
    {
      config: { id: "G-D66D2LYY0X" },
      appName: "MoneyBreeze",
      pageTrackerScreenviewEnabled: true,
      enabled: false,
      bootstrap: true,
      onError(error) {
        console.log(error);
      },
    },
    router
  )
  .use(router)
  .use(store)
  .use(vuetify)
  .use(createMetaManager())
  .use(metaPlugin);

appVue.mount("#app");
